<div class="form-modal">
    <div class="course-feedback">
        <a tabindex="0" (click)="onClose()" (keypress)="onClose()" class="close-modal"
            aria-label="Close course feedback form">
            <img src="./assets/img/icons-svg/close-icon.svg">
        </a>
        <div class="form-wrapper-80">
            <div class="title-wrapper">
                <h2 translate>Provide chapter feedback</h2>
            </div>
        </div>

        <div class="form-wrapper feedback-content">
            <div *ngIf="!submitted">
                <p class="left-align">This series increased my knowledge and/or understanding of the topic
                    discussed.</p>
                <div class="app-c-form-group">
                    <select class="app-c-form-control" [(ngModel)]="helpful" aria-required="true">
                        <option value="">-- Select --</option>
                        <option value="5">Strongly agree</option>
                        <option value="4">Neither agree nor disagree</option>
                        <option value="3">Agree</option>
                        <option value="2">Disagree</option>
                        <option value="1">Strongly disagree</option>
                    </select>
                </div>

            </div>
            <p *ngIf="submitted" class="strong">Thank you for your review.</p>
        </div>

        <div class="fixed-footer">
            <a tabindex="0" class="app-c-btn app-c-btn--primary app-c-btn--curve" (click)="doSave()">Send Feedback</a>
        </div>
    </div>
</div>